import Cms from '@components/cms/Cms.component';
import {getCmsPageProps} from '@utils/cms';

const Page = props => {
	const {cmsdata} = props;

	if (!cmsdata?.result?.cms) return null;

	return (
		<>
			<Cms cmsdata={cmsdata.result.cms}></Cms>
			<div id='dynamicstyle'></div>
		</>
	);
};

export async function getStaticProps({params}) {
	const slug = '/give-ditybit';
	const cmsdata = await getCmsPageProps(slug);

	return {
		props: {
			cmsdata,
		},
		revalidate: 60 * 15,
	};
}

Page.Layout = true;
export default Page;
